export default {
  text: 'This restaurant is suspended. Please get in touch your contact person or message us at <a>{{supportEmail}}</a> if you would like to restore',
};
